import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MuiButton from "@mui/material/Button";
import { useTranslation, Trans } from "react-i18next";
import React from "react";
import useDialogBackButton from "@/react/hooks/useDialogBackButton";
const CopyrightDialog = ({ open, onClose }) => {
    const [t] = useTranslation();
    // Hardware/browser back closes the dialog instead of navigating away.
    useDialogBackButton(open, onClose);
    return (React.createElement(Dialog, { open: open, onClose: onClose },
        React.createElement(DialogTitle, null, t("Copyrighted work")),
        React.createElement(DialogContent, null,
            React.createElement("p", null,
                React.createElement(Trans, null, "This work represents our time, effort and creativity.")),
            React.createElement("p", null,
                React.createElement(Trans, null, "Please show integrity and respect by not copying or sharing it without permission."))),
        React.createElement(DialogActions, null,
            React.createElement(MuiButton, { onClick: onClose, autoFocus: true, variant: "contained", color: "primary" }, t("I understand")))));
};
export default CopyrightDialog;
